import { Fragment, ReactNode, Suspense } from 'react';
import { Flex, Spinner } from '@chakra-ui/react';
import { Outlet, useOutlet } from 'react-router-dom';

export default function SpinnerSuspense({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <Flex
          flex="1"
          width="100%"
          height="100%"
          alignItems="center"
          justifyContent="center"
          p={10}
        >
          <Spinner variant="mooven" size="xl" data-ignore-visual-test />
        </Flex>
      }
    >
      {children}
    </Suspense>
  );
}

export function LazyOutlet() {
  const outlet = useOutlet();
  // Suspense doesn't hide content that has already been revealed. Once outlet is rendered, it will not be suspended again,
  // even if the outlet changes to a lazy-loaded route.
  // This means that if the outlet changes to a lazy-loaded route, the content of the previous route will still be visible until the new route is loaded.
  // This is not a problem for routes that are not lazy-loaded, as they will be rendered immediately.
  // However, for lazy-loaded routes, we need to reset the suspense boundary (https://react.dev/reference/react/Suspense#resetting-suspense-boundaries-on-navigation),
  // We use the matched pathname of the outlet to identify when a different route is being rendered at this level.
  const key = (outlet as any)?.props?.children?.props?.match?.pathname;
  return (
    <Fragment key={key}>
      <SpinnerSuspense>
        <Outlet />
      </SpinnerSuspense>
    </Fragment>
  );
}
